import React, { useState } from "react";
import "./Pravachan_Card.css";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Music_play_modal from "../../../common/modals/music-play-modal/Music_play_modal";
import { IDS } from "../../../../utils/IDS";
import Music_option_modal from "../../../common/modals/music-option-modal/Music_option_modal";

const Pravachan_Card = ({ name, musicList, album, music, image }) => {

  const [modalShow, setModalShow] = React.useState(false);
  const [modalShow2, setModalShow2] = React.useState(false);
  return (
    <div className="Pravachan_Card" >
      <div className="white_box" onClick={() => setModalShow2(true)}>
        <img
          src="/assets/gifs/insight/guru_pravachan/bg_gif.gif"
          className="gif_class"
        />

        <div className="overlay_holder">
          <img
            src={IDS.IMG_URL + image}
            className="baba_img"
          />
          {/* <img
            src="/assets/images/insight/guru_pravachan/baba.png"
            className="baba_img"
          /> */}
        </div>
      </div>
      <div className="bottom_div">
        <div className="main_div">
          <p className="title_text">{name || " "}</p>
          <p className="sub_text">{album || " "}</p>
        </div>
        <div className="option_div" onClick={() => setModalShow(true)}>
          <FontAwesomeIcon icon={faEllipsisV} className="option_icon" />
        </div>
      </div>

      <Music_option_modal
        music={music}
        musicList={musicList}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <Music_play_modal
        musicList={musicList}
        music={music}
        show={modalShow2}
        onHide={() => setModalShow2(false)}
      />
    </div>
  );
  // return (
  //   <div className="Pravachan_Card">
  //     <div className="white_box">
  //       <img
  //         src="/assets/gifs/insight/guru_pravachan/bg_gif.gif"
  //         className="gif_class"
  //       />

  //       <div className="overlay_holder">
  //         <img
  //           src="/assets/images/insight/guru_pravachan/baba.png"
  //           className="baba_img"
  //         />
  //       </div>
  //     </div>
  //     <div className="bottom_div">
  //       <div className="main_div">
  //         <p className="title_text">Nirvana Shatakam</p>
  //         <p className="sub_text">Vairagya Reprise</p>
  //       </div>
  //       <div className="option_div" onClick={() => setMusicModal(true)}>
  //         <FontAwesomeIcon icon={faEllipsisV} className="option_icon" />
  //       </div>
  //     </div>

  //     <Music_play_modal
  //       show={musicModal}
  //       onHide={() => setMusicModal(false)}
  //     />
  //   </div>
  // );
};

export default Pravachan_Card;
